{
  "placeholder": "Select an option…",
  "loading": "Loading…"
}
